import { render, staticRenderFns } from "./SectionEpisodeInformation.vue?vue&type=template&id=ede1f42e&scoped=true&"
import script from "./SectionEpisodeInformation.vue?vue&type=script&lang=js&"
export * from "./SectionEpisodeInformation.vue?vue&type=script&lang=js&"
import style0 from "./SectionEpisodeInformation.vue?vue&type=style&index=0&id=ede1f42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede1f42e",
  null
  
)

export default component.exports